import { useCallback, useState } from 'react';
import { PlaybackState } from '../../enums';
import { usePlaybackStateStore } from '../../store';
const { getState: getStateRaw, setState: setStateRaw, } = usePlaybackStateStore.getState();
export const useContentPlaybackState = (id) => {
    const [lastState, setLastState] = useState(PlaybackState.NONE);
    const computeState = useCallback((state, id) => {
        if (!id)
            return PlaybackState.NONE;
        const cur = usePlaybackStateStore.getState().getState(id);
        if (cur)
            return cur;
        else
            return PlaybackState.NONE;
    }, []);
    const state = usePlaybackStateStore(useCallback((state) => {
        const newState = computeState(state, id);
        return newState;
    }, [id]));
    const getState = useCallback((overrideId) => {
        if (!id && !overrideId)
            return;
        const stateId = (id || overrideId);
        return getStateRaw(stateId);
    }, [id]);
    const setState = useCallback((newState, overrideId) => {
        if (!id && !overrideId)
            return;
        const stateId = (id || overrideId);
        const oldState = overrideId ? getStateRaw(overrideId) : PlaybackState.NONE;
        setLastState(oldState);
        setStateRaw(stateId, newState);
    }, [id]);
    return {
        state,
        lastState,
        setState,
        getState,
    };
};
//# sourceMappingURL=useContentPlaybackState.js.map